import { RouteRecordRawArgumented } from 'src/types/route'
import useI18n from 'src/hooks/i18n'
import useRouteParser from 'src/hooks/routeParser'

const { t } = useI18n()
const { getPaginationInject, getPaginationCasts } = useRouteParser()

const module: RouteRecordRawArgumented = {
  path: 'stock-bot',
  name: 'stockBot',
  redirect: () => ({ name: 'stockBotPanoramica' }),
  meta: {
    breadcrumb: {
      name: t('breadcrumb.stock_bot.index'),
      icon: 'mdi-warehouse',
    },
    auth: {
      permission: 'stock_bot_access',
    },
  },
  children: [
    {
      path: 'panoramica',
      name: 'stockBotPanoramica',
      component: () =>
        import(
          /* webpackChunkName: "stock-bot-overview" */ 'pages/stock-bot/OverviewPage.vue'
        ),
      meta: {
        breadcrumb: {
          name: t('breadcrumb.stock_bot.panoramica'),
          icon: 'mdi-view-dashboard-outline',
        },
        auth: {
          permission: 'stock_bot_access',
        },
        inject: {
          query: {
            ...getPaginationInject(),
            sort: 'created_at',
            dir: 'desc',
          },
        },
        casts: {
          query: {
            ...getPaginationCasts(),
          },
        },
      },
    },
    {
      path: 'dettagli',
      name: 'stockBotDettagli',
      component: () =>
        import(
          /* webpackChunkName: "stock-bot-details" */ 'pages/stock-bot/DetailsPage.vue'
        ),
      meta: {
        breadcrumb: {
          name: t('breadcrumb.stock_bot.dettagli'),
          icon: 'mdi-information-outline',
        },
        auth: {
          permission: 'stock_bot_access',
        },
      },
    },
  ],
}

export default module
